
<style>
    .scafft,.scafft td{
    border: 1px solid black;
    }
  
    .scafft td {
    width:5%;
    height:25%;
    }
    .e-file-select-wrap{
        display: none !important;
    }
    #conTypeBtn {
        width: 45px!important;
        height: 35px;
        padding: 0px 0px 0px 0px;
    }
    #designContextMenu,#toolsContextMenu{
        width: 100px !important;
    }
    #editContextMenu{
        width: 120px !important;
    }
    #hideProperty{
        width: 28px;    
        height: 28px;
        margin-left: 30px;
        margin-bottom: 7px !important;
    }
    .db-toolbar-container{
        width: 100%!important;
    }
    .close{
        float: right;
        border-color: #b5b5b5;
    }
    #js-licensing{
        display: none;
    }   
    .pan-item{
        margin-left: 3px;
    } 
    .designMenu .e-contextmenu.e-menu-parent{
        width: auto!important;
    }
    .insertMenu .e-contextmenu.e-menu-parent{
        width: auto!important;
    }
   
</style>
<ejs-contextmenu id='designContextMenu' #designContextMenu 
 [items]='dropDownDataSources.getDesignMenuItems'
    (onOpen)='utilityMethods.designContextMenuOpen($event)' cssClass="designMenu" (beforeItemRender)="beforeItemRender($event)"
    (beforeClose)="utilityMethods.arrangeMenuBeforeClose($event)" (select)="menuClick($event)">
</ejs-contextmenu>
<div class='diagrambuilder-container'>

    <div class='db-toolbar-container'>
        <ejs-toolbar id='toolbarEditor' #toolbarEditor overflowMode='Scrollable' (created)="toolbarCreated()" (clicked)='toolbarEditorClick($event)'>
            <e-items>
                <e-item [visible]="false" prefixIcon="sf-icon-undo tb-icons" tooltipText="Undo" cssClass="tb-item-start tb-item-undo">
                </e-item>
                <e-item [visible]="false"prefixIcon="sf-icon-redo tb-icons" tooltipText="Redo" cssClass="tb-item-end tb-item-redo">
                </e-item>
                <e-item [visible]="false" type="Separator">
                </e-item>
                <e-item prefixIcon="sf-icon-pan tb-icons" tooltipText="Pan Tool" cssClass="tb-item-start pan-item">
                </e-item>
                <e-item prefixIcon="sf-icon-pointer tb-icons" tooltipText="Select Tool" cssClass="tb-item-middle tb-item-selected">
                </e-item>
                <e-item prefixIcon = 'sf-icon-straight_line' tooltipText = 'Straight' cssClass='tb-item-middle'></e-item>
                <e-item prefixIcon="sf-icon-text tb-icons" tooltipText="Text Tool" cssClass="tb-item-end">
                </e-item>
                <e-item prefixIcon="sf-icon-copy tb-icons" tooltipText="Duplicate" cssClass="tb-item-end">
                </e-item>
               
                  
                <e-item type="Separator" align="Center" [visible]="false">
                </e-item>
                <e-item prefixIcon="sf-icon-align_left tb-icons" [visible]="false" align ="Center" tooltipText="Align Left" cssClass="tb-item-start tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-align_center tb-icons" [visible]="false" align ="Center" tooltipText="Align Center" cssClass="tb-item-middle  tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-align_right tb-icons" [visible]="false" align ="Center" tooltipText="Align Right" cssClass="tb-item-middle tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-align_top tb-icons" [visible]="false" align ="Center" tooltipText="Align Top" cssClass="tb-item-middle tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-align_middle tb-icons" [visible]="false" align ="Center" tooltipText="Align Middle" cssClass="tb-item-middle tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-align_bottom tb-icons" [visible]="false" align ="Center" tooltipText="Align Bottom" cssClass="tb-item-middle tb-item-align-category">
                </e-item>
                <e-item prefixIcon="sf-icon-distribute_vertical tb-icons" [visible]="false" align ="Center" tooltipText="Distribute Objects Vertically" cssClass="tb-item-middle tb-item-space-category">
                </e-item>
                <e-item prefixIcon="sf-icon-distribute_horizontal tb-icons" [visible]="false" align ="Center" tooltipText="Distribute Objects Horizontally" cssClass="tb-item-end tb-item-space-category">
                </e-item>
                <e-item type="Separator" align ="Center" [visible]="false">
                </e-item>
                <e-item prefixIcon="sf-icon-bring-forward tb-icons" align ="Center" [visible]="false" tooltipText="Bring Forward" cssClass="tb-item-start tb-item-lock-category">
                </e-item>
                <e-item prefixIcon="sf-icon-bring-to-front tb-icons" align ="Center" [visible]="false" tooltipText="Bring To Front" cssClass="tb-item-middle tb-item-lock-category">
                </e-item>
                <e-item prefixIcon="sf-icon-send-backward tb-icons" align ="Center" [visible]="false" tooltipText="Send Backward" cssClass="tb-item-middle tb-item-lock-category">
                </e-item>
                <e-item prefixIcon="sf-icon-send-to-back tb-icons" align ="Center" [visible]="false" tooltipText="Send To Back" cssClass="tb-item-end tb-item-lock-category">
                </e-item>
                <e-item type="Separator" align ="Center" [visible]="false">
                </e-item>
                <e-item prefixIcon="sf-icon-lock tb-icons" align ="Center" [visible]="false" tooltipText="Lock" cssClass="tb-item-start tb-item-lock-category">
                </e-item>
                <e-item prefixIcon="sf-icon-delete tb-icons" align ="Center" [visible]="false" tooltipText="Delete" cssClass="tb-item-end tb-item-lock-category">
                </e-item>
                
                <e-item type="Separator" align ="Center" [visible]="false">
                </e-item>
                <e-item [visible]="true"  align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <div class="e-section-control">
                            <div style="width:250px;margin-right:80px;">
                                <label style="margin-right:10px;">{{lang.el('Descrizione')}}</label>
                                <input pInputText [(ngModel)]="cC.descrizione" class="flex-auto" autocomplete="off" />
                            </div>
                        </div>
                    </ng-template>
                </e-item>
                <e-item [visible]="true"  align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <div class="e-section-control">
                            <p-checkbox name="mostraMisure"  
                            (onChange)="showHideMostraMisure()"
                            [(ngModel)]="mostraMisure" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Mostra struttura')}}</label>
                            
                        </div>
                    </ng-template>
                </e-item>
                <e-item [visible]="utentevedeListini()"   tooltipText="{{lang.el('Listini')}}" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <div class="e-section-control">
                            <button 
                                pButton pRipple class="p-button-secondary flex-1 border-round" 
                                (click)="creaListini()"
                                [disabled]="mS.currCellaInd<0"
                                label="{{lang.el('Listini')}}" icon="pi pi-fw pi-check">
                            </button>  
                        </div>`
                    </ng-template>
                </e-item>             
                <e-item  tooltipText="{{lang.el('Disegna')}}" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <div class="e-section-control">
                            <button 
                                pButton pRipple class="p-button-secondary flex-1 border-round" 
                                (click)="draw3D()"
                                label="{{lang.el('Disegna')}}" icon="pi pi-fw pi-check">
                            </button>  
                        </div>`
                    </ng-template>
                </e-item>                 
                <e-item tooltipText="{{lang.el('Stampa tavole')}}" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                           <button 
                                pButton pRipple class="p-button-secondary flex-1 border-round" 
                                (click)="stampaTavole()"
                                [disabled]="!cC|| !cC.elencoCelle || cC.elencoCelle.length==0"
                                label="{{lang.el('Stampa tavole')}}" icon="pi pi-fw pi-check">
                            </button>  
                    </ng-template>
                </e-item>


                <e-item tooltipText="{{lang.el('Salva')}}" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                           <button 
                                pButton pRipple class="p-button-primary flex-1 border-round" 
                                (click)="saveCella()"
                                [disabled]="mS.isSaving || mostraMisure || !mS.distintaData || mS.distintaData.length==0 || cC.status=='INVIATA BC'"
                                label="{{lang.el('Salva cella')}}" icon="pi pi-fw pi-check">
                            </button>  
                    </ng-template>
                </e-item>
                  <e-item tooltipText="{{lang.el('Annulla')}}" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                            <button
                                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                                (click)="annullaEditor()"
                                label="{{lang.el('Annulla')}}">
                            </button>
                    </ng-template>
                </e-item>

                 
               
                <e-item tooltipText="Zoom" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <button pButton  severity="secondary"
                          (click)="zoom('plus')"
                        icon="pi pi-fw pi-plus"></button>
                          <button pButton  severity="secondary" style="margin-left:3px;"
                          (click)="zoom('minus')"
                        icon="pi pi-fw pi-minus"></button>
                    </ng-template>
                </e-item>
        
                 <e-item *ngIf="!mS.userCellePreConf()" tooltipText="Zoom" align ="Right" cssClass="tb-item-end tb-zoom-dropdown-btn">
                    <ng-template #template>
                        <p-button (onClick)="showPalette = !showPalette" icon="pi pi-window-maximize" />
                    </ng-template>
                 </e-item>
               
                
                <e-item tooltipText="{{lang.el('Nascondi/Mostra proprietà')}}" align ="Right">
                <ng-template #template>
                    <button ejs-button id="hideProperty" (click)="hideElements('hideProperty','hide-properties',diagram)" iconCss="sf-icon-properties" isPrimary="true">
                    </button>
                </ng-template>
                </e-item>
            </e-items>
        </ejs-toolbar>
    </div>
    <div class='grid' >
        <div class="col-2 pr-0" *ngIf="showPalette && !mS.userCellePreConf()">
             <p-tabView> 
                    <p-tabPanel header="{{lang.el('Celle/Impianti')}}">
                        <ejs-symbolpalette 
                            #symbolpalette 
                            [expandMode]='expandMode' 
                            [palettes]='palettes' 
                            [enableSearch]="true"
                            [locale]="lang.getLanguage()"
                            width="100%" height="100%" 
                            [symbolMargin]='symbolMargin' 
                            [getSymbolInfo]='getSymbolInfo' 
                            (paletteExpanding)="paletteExpanding($event)"
                            (paletteSelectionChange)="paletteSelectionChange($event)"
                            [getNodeDefaults]="setPaletteNodeDefaults"
                            >
                            </ejs-symbolpalette>
                    </p-tabPanel>
                      <p-tabPanel header="{{lang.el('Minicelle')}}">
                        <ejs-symbolpalette #symbolpaletteMC 
                            [expandMode]='expandMode' [palettes]='palettesMC' 
                            [enableSearch]="true"
                            [locale]="lang.getLanguage()"
                            width="100%" height="100%" 
                            (paletteSelectionChange)="paletteSelectionChange($event)"
                            (paletteExpanding)="paletteExpanding($event)"
                            [symbolMargin]='symbolMarginMC' [getSymbolInfo]='getSymbolInfoMC' 
                            [getNodeDefaults]="setPaletteNodeDefaultsMC"
                            >
                            </ejs-symbolpalette>
                    </p-tabPanel>
             </p-tabView>

                
      
        </div>
        <div class="col-2 pr-0" *ngIf="showPalette && mS.userCellePreConf()">
            <ejs-symbolpalette id="symbolpalette" 
                #symbolpalette 
                [expandMode]='expandMode' 
                [palettes]='palettes' 
                [enableSearch]="true"
                [locale]="lang.getLanguage()"
                width="100%" height="100%" 
                (paletteSelectionChange)="paletteSelectionChange($event)"
                (paletteExpanding)="paletteExpanding($event)"
                [symbolMargin]='symbolMargin' [getSymbolInfo]='getSymbolInfo' 
                [getNodeDefaults]="setPaletteNodeDefaults"
                >
                </ejs-symbolpalette>
        </div>
       
        <div class="{{showPalette ? 'col-10':'col-12'}}" style="position: relative;">
        
          <div style="width:100%; height:80vh;">
                   <ejs-diagram #diagram id="diagram" [nodes]="mS.nodes"  
                    width="100%" height="100%" 
                    [constraints]="diagramCostraint"
                    [getNodeDefaults]='setNodeDefaults'
                    [rulerSettings]="rulerSettings"
                    [commandManager]='commandManager'
                    [pageSettings]="pageSettings"
                    [scrollSettings]="scrollSettings"
                    [snapSettings]="snapSettings"
                    [contextMenuSettings]="contextMenu"
                    [layers]="layers"
                    (selectionChange)="selectionChange($event)"
                    (historyChange)="diagramClientSideEvents.historyChange()"
                    (sizeChange)="sizeChange($event)"
                    (rotateChange)="diagramClientSideEvents.rotateChange($event)"
                    (positionChange)="positionChange($event)"
                    (collectionChange)="diagramClientSideEvents.collectionChange($event)"
                    (dragEnter)="dragEnter($event)"
                    (drop)="drop($event)"
                    (loaded)="diagramLoaded($event)"
                    (created)="diagramCreated($event)"
                  >
                  </ejs-diagram>
     
          </div>
          <div 
          *ngIf="oneSelected()"
          class='db-property-editor-container' style="overflow:auto;">
              <div id="generalDiagramContainer" class="db-general-diagram-prop-container">
                    <div class="grid" *ngIf="whatsSelected('minicella')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà minicella')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <button type="button"
                                pButton pRipple
                                icon="pi pi-book"
                                (click)="showEditDescTecnica=true"
                                class="p-button-info"
                                label="{{lang.el('Descrizione')}}">
                            </button>  
                        </div>   
                     
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Altezza')}}</label>
                            <p-dropdown [options]="cC.elencoCelle[mS.currCellaInd].customClient=='Electrolux'? mS.altezzaMiniCelleOptionsElectrolux:mS.altezzaMiniCelleOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].altezza" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                         <div class="col-12 pt-1 pb-0"  >
                            <label>{{lang.el('Spessore')}}</label>
                            <p-dropdown [options]="mS.spessoreOptionsCombinate" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currCellaInd].spessore,'spessore');mS.onChangeSpessore(cC.elencoCelle[mS.currCellaInd],prev.lang)"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Impianto')}}</label>
                            <p-dropdown [options]="cC.elencoCelle[mS.currCellaInd].impiantiMiniCelleOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].minicellaImpianto" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Scaffali')}}</label>
                            <p-dropdown [options]="scaffaliMiniCelleOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].minicellaScaffale" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-2 pb-0">
                            <p-checkbox name="pavimenti"  
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.onChangeSpessore(cC.elencoCelle[mS.currCellaInd],prev.lang);"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].pavimenti" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Pavimenti')}}</label>
                        </div>
                    </div>
                    <div class="grid" *ngIf="whatsSelected('cella')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà cella')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <button type="button"
                                pButton pRipple
                                icon="pi pi-book"
                                (click)="showEditDescTecnica=true"
                                class="p-button-info"
                                label="{{lang.el('Descrizione')}}">
                            </button>  
                        </div>   
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Altezza')}}</label>
                            <p-dropdown [options]="mS.altezzaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="resetModelloPorta(cC.elencoCelle[mS.currCellaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].altezza" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Ingombro X')}}</label>
                            <p-inputNumber 
                            [disabled]="mS.isCustomDistinta() || disabledMoveOrResize()"
                            [min]="getMinIngombro()" [max]="getMaxIngombro()" 
                            (onBlur)="changeIngombri(cC.elencoCelle[mS.currCellaInd]);"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].ingombroX"></p-inputNumber>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Ingombro Y')}}</label>
                            <p-inputNumber 
                            [disabled]="mS.isCustomDistinta() || disabledMoveOrResize()"
                            [min]="getMinIngombro()" [max]="getMaxIngombro()" 
                            (onBlur)="changeIngombri(cC.elencoCelle[mS.currCellaInd]);"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].ingombroY"></p-inputNumber>
                        </div>
                        <div class="col-12 pt-1 pb-0"  >
                            <label>{{lang.el('Spessore')}}</label>
                            <p-dropdown [options]="mS.userCellePreConf() ? mS.spessoreOptionsCombinate : mS.spessoreOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currCellaInd].spessore,'spessore');mS.onChangeSpessore(cC.elencoCelle[mS.currCellaInd],prev.lang)"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                       
                        <div *ngIf="false && !mS.userCellePreConf()">
                            <label>{{lang.el('Tipo cella')}}</label>
                            <p-dropdown [options]="mS.tipoCellaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.changeTipoCella(cC)"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].tipoCella" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-1" ><br/>
                            <p-checkbox name="valvolaCompensazione"  
                            [disabled]="mS.isCustomDistinta()"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].valvolaCompensazione" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Valvola di compensazione')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <button type="button"
                                [disabled]="mS.isCustomDistinta() || !mS.distintaData || mS.distintaData.length==0"
                                pButton pRipple
                                icon="pi pi-cog"
                                (click)="apriOpzioni(cC.elencoCelle[mS.currCellaInd],mS.currCellaInd)"
                                class="p-button-info"
                                label="{{lang.el('Opzioni cella')}}">
                            </button>  
                        </div>    
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()">
                            <h5 style="padding-bottom: 0;margin-bottom: 0;">{{lang.el('Pareti')}}</h5>
                        </div>                 
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.finituraOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currCellaInd].finitura,'finitura');mS.onChangeFinitura(cC.elencoCelle[mS.currCellaInd],prev.lang)"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].finitura" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()">
                            <label>{{lang.el('Finitura angolari')}}</label>
                            <p-dropdown [options]="mS.finituraAngolariOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].finituraangolari" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>        
                       
                        <div class="col-12 pt-2 pb-0" *ngIf="mS.userCellePreConf()">
                            <p-checkbox name="scaffalecellepre"  
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].scaffaliCellePreconf" 
                            (onChange)="changeScaffaliCellePreConf(cC.elencoCelle[mS.currCellaInd])"
                            styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Scaffali')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoCelle[mS.currCellaInd].scaffaliCellePreconf">
                            <p-dropdown [options]="cC.elencoCelle[mS.currCellaInd].scaffaliCellePreconfTipoOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="setScaffaliCellePreConf(cC.elencoCelle[mS.currCellaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].scaffaliCellePreconfCodice" 
                            [style]="{'width':'100%'}"
                            [group]="true">
                            <ng-template let-group pTemplate="group">
                                <div class="flex align-items-center">
                                    <b>{{ group.label }}</b>
                                </div>
                            </ng-template>
                            </p-dropdown>
                        </div>
                        <div class="col-12 pt-2 pb-0">
                            <p-checkbox name="pavimenti"  
                            [disabled]="mS.isCustomDistinta() || cC.elencoCelle[mS.currCellaInd].spessore==13"
                            (onChange)="mS.onChangeSpessore(cC.elencoCelle[mS.currCellaInd],prev.lang);"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].pavimenti" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Pavimenti')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf() && cC.elencoCelle[mS.currCellaInd].pavimenti">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.finituraPavimentoOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            optionLabel="label" optionValue="value"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].finituraPavimento" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()  && cC.elencoCelle[mS.currCellaInd].pavimenti"><br/>
                            <p-checkbox name="ruotaPavimento"  
                            [disabled]="mS.isCustomDistinta()"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].ruotaPavimento" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Ruota pavimento')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0" ><br/>
                            <p-checkbox name="vespaio"  *ngIf="cC.elencoCelle[mS.currCellaInd].pavimenti"
                            [disabled]="mS.isCustomDistinta() || (mS.userCellePreConf() && cC.elencoCelle[mS.currCellaInd].spessore==10)"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].vespaio" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Vespaio')}}</label>
                        </div>
                       
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoCelle[mS.currCellaInd].vespaio && !mS.userCellePreConf()">
                            <label>{{lang.el('Passo')}}</label>
                            <p-dropdown [options]="mS.passoOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].passo" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div *ngIf="cC.elencoCelle[mS.currCellaInd].vespaio && !mS.userCellePreConf()"
                             class="col-12 pt-1 pb-0" >
                            <label>{{lang.el('Altezza')}}</label>
                            <p-dropdown [options]="mS.altezzaOrizzOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currCellaInd].altezzaOrizz" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()"><br/>
                            <p-checkbox name="ruotasoffitto"  
                            [disabled]="mS.isCustomDistinta()"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].ruotasoffitto" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Ruota soffitto')}}</label>
                        </div>
                        
                        <div class="col-12 pt-1 pb-0"*ngIf="!mS.userCellePreConf()"><br/>
                            <p-checkbox name="soffittoMAXI"  
                            [disabled]="mS.isCustomDistinta()"
                            [(ngModel)]="cC.elencoCelle[mS.currCellaInd].soffittoMAXI" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Soffitto MAXI')}}</label>
                        </div>
                        
                    </div>
                    <div class="grid" *ngIf="whatsSelected('scaffale') && cC.elencoScaffali.length>0">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà scaffale')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Allinea')}}</label>
                            <p-dropdown [options]="allineamentoScaffaleOptions" 
                                [disabled]="mS.isCustomDistinta()"
                                appendTo="body" [(ngModel)]="allineamentoScaffale" 
                                (onChange)="changeAllineamentoScaffale()"
                                [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Larghezza')}}</label>
                            <p-inputNumber 
                            [disabled]="mS.isCustomDistinta()"
                            (onBlur)="refreshDiagram(cC.elencoScaffali[mS.currScaffaleInd].width,'widthScaffale');changeScaffale(cC.elencoScaffali[mS.currScaffaleInd])"
                            [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].width"></p-inputNumber>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Altezza')}}</label>
                            <p-dropdown [options]="mS.scaffaliAltezzeOptions" 
                                [disabled]="mS.isCustomDistinta()"
                                appendTo="body" [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].altezza" 
                                (onChange)="changeScaffale(cC.elencoScaffali[mS.currScaffaleInd])"
                                [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                          <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Numero ripiani')}}</label>
                            <p-dropdown [options]="mS.scaffaliRipianiOptions" 
                                [disabled]="mS.isCustomDistinta()"
                                appendTo="body" [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].numeroRipiani" 
                                [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-1">
                            <p-checkbox name="scaffaliUniti"  
                            [disabled]="mS.isCustomDistinta() || checkScaffaliUniti(cC.elencoScaffali[mS.currScaffaleInd].scaffaliUniti)"
                            (onChange)="refreshDiagram(cC.elencoScaffali[mS.currScaffaleInd].scaffaliUniti,'scaffaliUniti')"
                            [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].scaffaliUniti" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('scaffale unito')}}</label>    
                        </div>
                        <div class="col-12 pt-1 pb-1">
                            <p-checkbox name="scaffalebloccato"  
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoScaffali[mS.currScaffaleInd].scaffaleBloccato,'scaffaleBloccato')"
                            [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].scaffaleBloccato" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('scaffale bloccato')}}</label>    
                        </div>
                        <div class="col-12 pt-1 pb-0"><h5>{{lang.el('Distinta scaffali')}}</h5></div>
                        <div class="col-10 pt-1 pb-0 pl-2">
                            <table>
                                <tr *ngFor="let sc of cC.elencoScaffali[mS.currScaffaleInd].elenco;index as i">
                                    <td><b>{{lang.el('Larghezza')}} {{sc.lung}}: {{lang.el('Nr.')}} {{sc.qty}}</b></td>
                                </tr>
                                <tr *ngIf="cC.elencoScaffali[mS.currScaffaleInd].elenco.length>0">
                                    <td>
                                        <button pButton  severity="secondary"
                                        (click)="mostraElencoScaffali()"
                                        icon="pi pi-fw pi-book"></button>
                                    </td>
                                </tr>
                            </table>
                         </div>

                     
                        
                    </div>
              
                    <div class="grid" *ngIf="whatsSelected('duescaffali')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà scaffali uniti')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                         <div class="col-12 pt-1 pb-1">
                            <p-checkbox name="scaffaliUniti"  
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoScaffali[mS.currScaffaleInd].scaffaliUniti,'scaffaliUniti')"
                            [(ngModel)]="cC.elencoScaffali[mS.currScaffaleInd].scaffaliUniti" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('gli scaffali sono uniti')}}</label>    
                        </div>
                        
                    </div>
                    <div class="grid" *ngIf="whatsSelected('impiantiremoti')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà Impianto')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. interna')}}</label>
                            <p-dropdown [options]="mS.impiantiRemotiOptions[mS.currimpiantiRemotiTipo].IdTemperaturaInterna" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            (onChange)="mS.changeImpiantoRemotoOptions2(cC,mS.currImpiantoInd)"
                            [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].tempInt" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. esterna')}}</label>
                             <p-dropdown [options]="mS.impiantiRemotiOptions[mS.currimpiantiRemotiTipo].IdTemperaturaEsterna" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            (onChange)="mS.changeImpiantoRemotoOptions2(cC,mS.currImpiantoInd)"
                            [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].tempEst" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="mS.impiantoRemotoTipiOpt.length>0">
                            <label>{{lang.el('Tipo impianto')}}</label>
                               <p-dropdown [options]="mS.impiantoRemotoTipiOpt" 
                                    [disabled]="mS.isCustomDistinta()"
                                    appendTo="body" 
                                    (onChange)="mS.changeImpiantoRemoto(cC,mS.currImpiantoInd)"
                                    [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].art_comp" 
                                    [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        
                        <div class="col-12 pt-3 pb-0" *ngIf="mS.impiantoRemotoTipiOpt.length>0 && cC.elencoImpiantiRemoti[mS.currImpiantoInd].opzioni">
                            <p-button (onClick)="opLL.toggle($event)" icon="pi pi-cog" label="{{lang.el('Configurazione')}}" />
                                <p-overlayPanel #opLL
                                    [dismissable]="false"
                                    [showCloseIcon]="true">
                                    <div class="flex flex-column gap-3 w-30rem">
                                        <div class="grid">
                                            <div class="col-12 pb-0">
                                                <h5 *ngIf="cC.elencoImpiantiRemoti[mS.currImpiantoInd].tipoImpianto">{{lang.el('Configurazione')}}  
                                                    {{cC.elencoImpiantiRemoti[mS.currImpiantoInd].tipoImpianto}}</h5>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.impiantoRemotoMandatory;index as i">
                                                <label style="font-weight: 600;">{{optList.label}}:</label>
                                                <p-dropdown [options]="optList.items"
                                                    [showClear]="true"
                                                    [disabled]="mS.isCustomDistinta()"
                                                    appendTo="body" 
                                                    [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].mandatory[i]" 
                                                    [style]="{'width':'100%'}">
                                                </p-dropdown>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.impiantoRemotoOpzioni;index as i">
                                                <div *ngIf="optList.value!='SET TUB.'">
                                                    <label style="font-weight: 600;">{{optList.label}}:</label>
                                                    <p-dropdown [options]="optList.items"
                                                        [showClear]="true"
                                                        [disabled]="mS.isCustomDistinta() "
                                                        appendTo="body" 
                                                       [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].opzioni[i]" 
                                                        [style]="{'width':'100%'}">
                                                    </p-dropdown>
                                                    
                                                </div>
                                            </div>
                                            <div class="{{optList.value=='SET TUB.'?'col-12':''}} pt-0" *ngFor="let optList of mS.impiantoRemotoOpzioni;index as i">
                                                <div class="grid" *ngIf="optList.value=='SET TUB.'">
                                                    <div class="col-6 pt-0">
                                                        <label style="font-weight: 600;">{{optList.label}}:</label>
                                                        <p-dropdown [options]="optList.items"
                                                                    [showClear]="true"
                                                                    [disabled]="mS.isCustomDistinta()"
                                                                    appendTo="body" 
                                                                    [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].opzioni[i]" 
                                                                    [style]="{'width':'100%'}">
                                                        </p-dropdown>
                                                     </div>
                                                     <div class="col-6 pt-0" *ngIf="cC.elencoImpiantiRemoti[mS.currImpiantoInd].opzioni[i]">
                                                        <label style="font-weight: 600;">{{lang.el('Qtà')}}:</label>
                                                         <p-dropdown [options]="mS.impiantoNumerotubiList"
                                                                    [disabled]="mS.isCustomDistinta()"
                                                                    (onChange)="mS.changeImpiantoRemotoTubi(cC,mS.currImpiantoInd,cC.elencoImpiantiRemoti[mS.currImpiantoInd].opzioni[i])"
                                                                    appendTo="body" 
                                                                    [(ngModel)]="cC.elencoImpiantiRemoti[mS.currImpiantoInd].numerotubi" 
                                                                    [style]="{'width':'100%'}">
                                                        </p-dropdown>
                                                     </div>
                                                </div>
                                            </div>
                                            <div class="col-12 text-right">
                                                <button  
                                                    pButton pRipple class="p-button-primary flex-1 border-round" 
                                                    (click)="opLL.toggle($event)"
                                                    label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
                                            </div>
                                        </div>
                                    </div>
                                </p-overlayPanel>
                            
                        </div>
                    </div>
                    <div class="grid" *ngIf="whatsSelected('freeblock')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà freeblock')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Spessore')}}</label>
                            <p-dropdown [options]="mS.spessoreDroInOptions"
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            (onChange)="mS.changeFreeBlockOptions(cC,mS.currFreeBlockInd,prev)"
                            [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. interna')}}</label>
                            <p-dropdown [options]="mS.tempInt"  *ngIf="cC.elencoFreeBlocks[mS.currFreeBlockInd].spessore && cC.elencoFreeBlocks[mS.currFreeBlockInd].spessore==10"
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                             (onChange)="mS.changeFreeBlockOptions(cC,mS.currFreeBlockInd,prev)"
                            [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].tempInt" 
                            [style]="{'width':'100%'}"></p-dropdown>
                            <p-dropdown [options]="mS.tempIntSp6"  *ngIf="cC.elencoFreeBlocks[mS.currFreeBlockInd].spessore && cC.elencoFreeBlocks[mS.currFreeBlockInd].spessore==6"
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                             (onChange)="mS.changeFreeBlockOptions(cC,mS.currFreeBlockInd,prev)"
                            [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].tempInt" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. esterna')}}</label>
                            <p-dropdown [options]="mS.tempEst" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                             (onChange)="mS.changeFreeBlockOptions(cC,mS.currFreeBlockInd,prev)"
                            [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].tempEst" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                       
                        
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Controllore')}}</label>
                            <p-dropdown [options]="mS.controlloreOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            (onChange)="mS.changeFreeBlockOptions(cC,mS.currFreeBlockInd,prev)"
                            [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].controllore"
                            ></p-dropdown> 
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="mS.freeblocksTipiOpt.length>0">
                            <label>{{lang.el('Tipo impianto')}}</label>
                            <p-dropdown [options]="mS.freeblocksTipiOpt" 
                                [disabled]="mS.isCustomDistinta()"
                                appendTo="body" 
                                (onChange)="mS.setFreeBlock(cC,mS.currFreeBlockInd,prev)"
                                [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].art_comp" 
                                [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoFreeBlocks[mS.currFreeBlockInd].descFreeBlock">
                             <label>{{lang.el('Tipo impianto')}}:</label>
                             <div style="font-weight:700;">
                                {{cC.elencoFreeBlocks[mS.currFreeBlockInd].descFreeBlock}}
                             </div>
                        </div> 
                        <div class="col-12 pt-1 pb-0" >
                            <p-checkbox name="accessorio_resistenza_carter"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].accessorio_resistenza_carter" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Accessorio resistenza carter')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoFreeBlocks[mS.currFreeBlockInd].controllore!='Carel'">
                            <p-checkbox name="accessorio_bus_adapter"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].accessorio_bus_adapter" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Accessorio bus adapter')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <p-checkbox name="accessorio_bacinella_acqua"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoFreeBlocks[mS.currFreeBlockInd].accessorio_bacinella_acqua" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Accessorio bacinella acqua')}}</label>
                        </div>
                    </div>
                    <div class="grid" *ngIf="whatsSelected('dropin')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà dropin')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Spessore')}}</label>
                            <p-dropdown [options]="mS.spessoreDroInOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            (onChange)="mS.changeDropinOptionms(cC,mS.currDropinInd)"
                            [(ngModel)]="cC.elencoDropin[mS.currDropinInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. interna')}}</label>

                            <p-dropdown [options]="mS.tempInt" *ngIf="cC.elencoDropin[mS.currDropinInd].spessore && cC.elencoDropin[mS.currDropinInd].spessore!=6"
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.changeDropinOptionms(cC,mS.currDropinInd)"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoDropin[mS.currDropinInd].tempInt" 
                            [style]="{'width':'100%'}"></p-dropdown>
                            <p-dropdown [options]="mS.tempIntSp6" *ngIf="cC.elencoDropin[mS.currDropinInd].spessore && cC.elencoDropin[mS.currDropinInd].spessore==6"
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.changeDropinOptionms(cC,mS.currDropinInd)"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoDropin[mS.currDropinInd].tempInt" 
                            [style]="{'width':'100%'}"></p-dropdown>

                                                    
                          
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Temp. esterna')}}</label>
                            <p-dropdown [options]="mS.tempEst" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.changeDropinOptionms(cC,mS.currDropinInd)"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoDropin[mS.currDropinInd].tempEst" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                         <div class="col-12 pt-1 pb-0" *ngIf="mS.dropinTipiOpt.length>0">
                            <label>{{lang.el('Tipo impianto')}}</label>
                            <p-dropdown [options]="mS.dropinTipiOpt" 
                                [disabled]="mS.isCustomDistinta()"
                                appendTo="body" 
                                (onChange)="mS.setDropin(cC,mS.currDropinInd)"
                                [(ngModel)]="cC.elencoDropin[mS.currDropinInd].art_comp" 
                                [style]="{'width':'100%'}"></p-dropdown>
                        </div>

                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoDropin[mS.currDropinInd].descDropIn">
                             <label>{{lang.el('Descrizione')}}:</label>
                             <div style="font-weight:700;">
                                {{cC.elencoDropin[mS.currDropinInd].descDropIn}}
                             </div>
                        </div> 
                        <div class="col-12 pt-1 pb-0">
                            <p-checkbox name="accessorio_bus_adapter"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoDropin[mS.currDropinInd].accessorio_bus_adapter" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Accessorio bus adapter')}}</label>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <p-checkbox name="accessorio_bacinella_acqua"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoDropin[mS.currDropinInd].accessorio_bacinella_acqua" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Accessorio bacinella acqua')}}</label>
                        </div>
                    </div>

                    <div class="grid" *ngIf="whatsSelected('pannellopareti')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà pannello')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Spessore')}}</label>
                            <p-dropdown [options]="mS.spessoreOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currPannelloCellaInd].pannellicustom[mS.currPannelloCellaLato][mS.currPannelloInd].spessore,'spessorepannello')"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoCelle[mS.currPannelloCellaInd].pannellicustom[mS.currPannelloCellaLato][mS.currPannelloInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                         <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.finituraOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currPannelloCellaInd].pannellicustom[mS.currPannelloCellaLato][mS.currPannelloInd].finitura,'finiturapannello')"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currPannelloCellaInd].pannellicustom[mS.currPannelloCellaLato][mS.currPannelloInd].finitura" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                    </div>

                    <div class="grid" *ngIf="whatsSelected('angolare')">
                        <div class="col-8">
                            <b>{{lang.el('Proprietà angolare')}}</b>
                        </div>
                        <div class="col-4 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                         <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.finituraOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="refreshDiagram(cC.elencoCelle[mS.currAngolareCellaInd].angolaricustom[mS.currAngolareAngolo].finitura,'finiturapannello')"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.currAngolareCellaInd].angolaricustom[mS.currAngolareAngolo].finitura" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                    </div>
                    
                    <div class="grid" *ngIf="whatsSelected('porta')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà porta')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Tipologia')}}</label>
                            <p-dropdown [options]="mS.tipologiaPortaOptions" 
                            [disabled]="true"
                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].tipologiaPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                      
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Distanza porta')}}</label>
                            <div class="grid" style="width:100%">
                                <div class="col-1  pb-0">
                                    0
                                </div>
                                <div class="col-8  pb-0 text-center"
                                    *ngIf="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].lato_porta=='lato_ds'
                                        || cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].lato_porta=='lato_fronte'">
                                    <b>{{cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].distSnPorta}}/
                                        {{mS.distSnPortaOptions[mS.distSnPortaOptions.length-1]-cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].distSnPorta}}
                                    </b>
                                </div>
                                <div class="col-8  pb-0 text-center"
                                    *ngIf="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].lato_porta=='lato_sn'
                                        || cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].lato_porta=='lato_retro'">
                                    <b>{{mS.distSnPortaOptions[mS.distSnPortaOptions.length-1]-cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].distSnPorta}}/
                                        {{cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].distSnPorta}}
                                    </b>
                                </div>
                                <div class="col-1 pb-0">
                                    {{mS.distSnPortaOptions[mS.distSnPortaOptions.length-1]}} 
                                </div>
                                <div class="col-12  pb-0">
                               
                                    <p-slider 
                                        step="20"
                                        appendTo="body" 
                                        [min]="0"
                                        [max]="mS.distSnPortaOptions[mS.distSnPortaOptions.length-1]"
                                        (onChange)="changeDistPorta()"
                                        [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].distSnPorta"
                                        [style]="{'width':'100%'}" >
                                    </p-slider>
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Verso apertura')}}</label>
                            <p-dropdown [options]="mS.versoaperturaPortaOptions" 
                             [disabled]="mS.isCustomDistinta()"
                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd]);changeVersoApe(cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].versoAperturaPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-6 pt-1 pb-0" *ngIf="false">
                            <label>{{lang.el('Pavimento')}}</label>
                            <p-dropdown [options]="mS.pavimentoPortaOptions" 
                            [disabled]="mS.isCustomDistinta() "
                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].pavimentoPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        
                        
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoCelle[mS.cellaCollegataInd] && !cC.elencoCelle[mS.cellaCollegataInd].isMiniCella">
                            <label>{{lang.el('Tipo')}}</label>
                            <p-dropdown [options]="mS.tipo1PortaOptions" 
                            [disabled]="mS.isCustomDistinta() || mS.userCellePreConf()"
                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].tipo1Porta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf() && cC.elencoCelle[mS.cellaCollegataInd]  && !cC.elencoCelle[mS.cellaCollegataInd].isMiniCella">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.tipoPortaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].tipoPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Modello')}}</label>
                            <p-dropdown [options]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].modelliPortaOptions" 
                            [disabled]="mS.isCustomDistinta() || (cC.elencoCelle[mS.cellaCollegataInd] && cC.elencoCelle[mS.cellaCollegataInd].isMiniCella)"
                            (onChange)="mS.setModelloPorta(cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])"
                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].modelloPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].luceNetta">
                            <label>{{lang.el('Luce netta')}}</label>
                            <div>{{cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].luceNetta}}</div>
                        </div>   
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf() && cC.elencoCelle[mS.cellaCollegataInd]  && !cC.elencoCelle[mS.cellaCollegataInd].isMiniCella">
                            <p-checkbox name="strisceporta"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].strisceporta" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Strisce porta')}}</label>
                        </div>  
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf() 
                        && cC.elencoCelle[mS.cellaCollegataInd] 
                        && !cC.elencoCelle[mS.cellaCollegataInd].isMiniCella
                        && cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].modelloPorta!=''">
                            <p-checkbox name="configurata"  
                                [disabled]="mS.isCustomDistinta() || cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].modelloPorta==''"
                                (onChange)="mS.changeConfigurataPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])" 
                                [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].configurata" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Configurata')}}</label>
                        </div> 
                        <div class="col-12 pt-1 pb-0" *ngIf="mS.isconOblo(cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])">
                            <p-checkbox name="conoblo"  
                                [disabled]="mS.isCustomDistinta()"
                                (onChange)="mS.changeConfigurataPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd])" 
                                [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].conoblo" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('con oblò')}}</label>
                        </div> 
                        <div class="col-12 pt-3 pb-0" *ngIf="mS.portaConfigurataOpzioni.length>0 && cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].configurata">
                            <p-button (onClick)="opLLPP.toggle($event)" icon="pi pi-cog" label="{{lang.el('Configurazione')}}" />
                                <p-overlayPanel #opLLPP
                                    [dismissable]="false"
                                    [showCloseIcon]="true">
                                    <div class="flex flex-column gap-3 w-30rem">
                                        <div class="grid">
                                            <div class="col-12 pb-0">
                                                <h5>{{lang.el('Configurazione')}}</h5>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.portaConfigurataOpzioni;index as i">
                                                <label style="font-weight: 600;">{{optList.label}}:</label>
                                                <p-dropdown [options]="optList.items"
                                                    [showClear]="true"
                                                    [disabled]="mS.isCustomDistinta()"
                                                    appendTo="body" 
                                                    [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].configurataOpzioni[i]" 
                                                    [style]="{'width':'100%'}">
                                                </p-dropdown>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.portaConfigurataMandatory;index as i">
                                                <div >
                                                    <label style="font-weight: 600;">{{optList.label}}:</label>
                                                    <p-dropdown [options]="optList.items"
                                                        [showClear]="true"
                                                        [disabled]="mS.isCustomDistinta() "
                                                        appendTo="body" 
                                                       [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].elencoPorte[mS.currPortaInd].configurataMandatory[i]" 
                                                        [style]="{'width':'100%'}">
                                                    </p-dropdown>
                                                    
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 text-right">
                                                <button  
                                                    pButton pRipple class="p-button-primary flex-1 border-round" 
                                                    (click)="opLLPP.toggle($event)"
                                                    label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
                                            </div>
                                        </div>
                                    </div>
                                </p-overlayPanel>
                            
                        </div>


             
                    </div>
                    <div class="grid" *ngIf="whatsSelected('portascollegata')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà porta')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Altezza cella')}}</label>
                            <p-dropdown [options]="mS.altezzaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].altezza" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>

                        <div class="col-12 pt-1 pb-0"  >
                            <label>{{lang.el('Spessore cella')}}</label>
                            <p-dropdown [options]="mS.spessoreOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.onChangeSpessorePortaScollegata(cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].spessore" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>

                                  
                        <div class="col-12 pt-1 pb-0"  >
                            <p-checkbox name="montatasudivisorio"  
                            [disabled]="mS.isCustomDistinta()"
                             (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].montataSuDivisorio" 
                            styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Montata su divisorio')}}</label>
                        </div>


                        <div class="col-12 pt-2 pb-0">
                            <p-checkbox name="pavimenti"  
                            [disabled]="mS.isCustomDistinta()"
                             (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].pavimenti" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Pavimenti cella')}}</label>
                        </div>

                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Tipologia')}}</label>
                            <p-dropdown [options]="mS.tipologiaPortaOptions" 
                            [disabled]="true"
                            (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].tipologiaPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-6 pt-1 pb-0">
                            <label>{{lang.el('Verso apertura')}}</label>
                            <p-dropdown [options]="mS.versoaperturaPortaOptions" 
                             [disabled]="mS.isCustomDistinta()"
                            (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd]);changeVersoApe(cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].versoAperturaPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-6 pt-1 pb-0" *ngIf="false">
                            <label>{{lang.el('Pavimento')}}</label>
                            <p-dropdown [options]="mS.pavimentoPortaOptions" 
                            [disabled]="mS.isCustomDistinta() "
                            (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].pavimentoPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Tipo')}}</label>
                            <p-dropdown [options]="mS.tipo1PortaOptions" 
                            [disabled]="mS.isCustomDistinta() || mS.userCellePreConf()"
                            (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].tipo1Porta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()">
                            <label>{{lang.el('Finitura')}}</label>
                            <p-dropdown [options]="mS.tipoPortaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="changeModPorta($event,mS.initCella([],'',false),cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].tipoPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0">
                            <label>{{lang.el('Modello')}}</label>
                            <p-dropdown [options]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].modelliPortaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.setModelloPorta(null,cC.elencoPorteScollegate[mS.currPortaScollegataInd])"
                            appendTo="body" [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].modelloPorta" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-0" *ngIf="cC.elencoPorteScollegate[mS.currPortaScollegataInd].luceNetta">
                            <label>{{lang.el('Luce netta')}}</label>
                            <div>{{cC.elencoPorteScollegate[mS.currPortaScollegataInd].luceNetta}}</div>
                        </div>   
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf()">
                            <p-checkbox name="strisceporta"  
                                [disabled]="mS.isCustomDistinta()"
                                [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].strisceporta" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Strisce porta')}}</label>
                        </div>  
                        <div class="col-12 pt-1 pb-0" *ngIf="!mS.userCellePreConf() 
                        && cC.elencoPorteScollegate[mS.currPortaScollegataInd].modelloPorta!=''">
                            <p-checkbox name="configurata"  
                                [disabled]="mS.isCustomDistinta() || cC.elencoPorteScollegate[mS.currPortaScollegataInd].modelloPorta==''"
                                (onChange)="mS.changeConfigurataPorta($event,null,cC.elencoPorteScollegate[mS.currPortaScollegataInd])" 
                                [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].configurata" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('Configurata')}}</label>
                        </div> 
                        <div class="col-12 pt-1 pb-0" *ngIf="mS.isconOblo(cC.elencoPorteScollegate[mS.currPortaScollegataInd])">
                            <p-checkbox name="conoblo"  
                                [disabled]="mS.isCustomDistinta()"
                                (onChange)="mS.changeConfigurataPorta($event,null,cC.elencoPorteScollegate[mS.currPortaScollegataInd])" 
                                [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].conoblo" styleClass="mr-2" [binary]="true">
                            </p-checkbox>
                            <label>{{lang.el('con oblò')}}</label>
                        </div> 
                        <div class="col-12 pt-3 pb-0" *ngIf="mS.portaConfigurataOpzioni.length>0 && cC.elencoPorteScollegate[mS.currPortaScollegataInd].configurata">
                            <p-button (onClick)="opLLPP2.toggle($event)" icon="pi pi-cog" label="{{lang.el('Configurazione')}}" />
                                <p-overlayPanel #opLLPP2
                                    [dismissable]="false"
                                    [showCloseIcon]="true">
                                    <div class="flex flex-column gap-3 w-30rem">
                                        <div class="grid">
                                            <div class="col-12 pb-0">
                                                <h5>{{lang.el('Configurazione')}}</h5>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.portaConfigurataOpzioni;index as i">
                                                <label style="font-weight: 600;">{{optList.label}}:</label>
                                                <p-dropdown [options]="optList.items"
                                                    [showClear]="true"
                                                    [disabled]="mS.isCustomDistinta()"
                                                    appendTo="body" 
                                                    [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].configurataOpzioni[i]" 
                                                    [style]="{'width':'100%'}">
                                                </p-dropdown>
                                            </div>
                                            <div class="col-6 pt-0" *ngFor="let optList of mS.portaConfigurataMandatory;index as i">
                                                <div >
                                                    <label style="font-weight: 600;">{{optList.label}}:</label>
                                                    <p-dropdown [options]="optList.items"
                                                        [showClear]="true"
                                                        [disabled]="mS.isCustomDistinta() "
                                                        appendTo="body" 
                                                       [(ngModel)]="cC.elencoPorteScollegate[mS.currPortaScollegataInd].configurataMandatory[i]" 
                                                        [style]="{'width':'100%'}">
                                                    </p-dropdown>
                                                    
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 text-right">
                                                <button  
                                                    pButton pRipple class="p-button-primary flex-1 border-round" 
                                                    (click)="opLLPP2.toggle($event)"
                                                    label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
                                            </div>
                                        </div>
                                    </div>
                                </p-overlayPanel>
                            
                        </div>


             
                    </div>

                    <div class="grid" *ngIf="whatsSelected('combinata') && mS.cellaCombinataDiverseMisure">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà combinazione')}} {{mS.currCellaInd}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-1">
                            <label>{{lang.el('Collega come')}}</label>
                            <p-dropdown [options]="mS.tipoCollegamentoCellaOptions2" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoCelle[mS.cellaCombinataInd].tipoCollegamento" 
                            (onChange)="mS.changeCollegamentoCella($event,cC.elencoCelle[this.mS.currCellaInd]);refreshDiagram(cC.elencoCelle[mS.cellaCombinataInd].tipoCollegamento,'tipoCollegamento');"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                    </div>
                    <div class="grid" *ngIf="whatsSelected('combinata') && !mS.cellaCombinataDiverseMisure">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà combinazione')}} {{mS.currCellaInd}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-1">
                            <label>{{lang.el('Collega come')}}</label>
                            <p-dropdown [options]="mS.tipoCollegamentoCellaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoCelle[mS.cellaCombinataInd].tipoCollegamento" 
                            (onChange)="mS.changeCollegamentoCella($event,cC.elencoCelle[this.mS.currCellaInd]);refreshDiagram(cC.elencoCelle[mS.cellaCombinataInd].tipoCollegamento,'tipoCollegamento');"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                    </div>
                    
                    <div class="grid" *ngIf="whatsSelected('collegate')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà celle')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>
                        <div class="col-12 pt-1 pb-1">
                            <p-checkbox name="attivo"  
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="collegaCelle(cC.elencoCelle[this.mS.currCellaInd],cC.elencoCelle[this.mS.cellaCollegataInd]);" 
                            [(ngModel)]="mS.currCollegamento.attivo" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Celle unite')}}</label>
                        </div> 
                        <div class="col-12 pt-1 pb-1" *ngIf="mS.currCollegamento.attivo">
                             <p-dropdown [options]="mS.collegamentoCellaOptions" 
                            [disabled]="mS.isCustomDistinta()"
                            appendTo="body" 
                            [(ngModel)]="mS.currCollegamento.tipoCollegamento" 
                            (onChange)="refreshCollegamento();"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>

                    </div>

                    <div class="grid" *ngIf="whatsSelected('divisorio')">
                        <div class="col-6">
                            <b>{{lang.el('Proprietà divisorio')}}</b>
                        </div>
                        <div class="col-6 text-right">
                            <p-button icon="pi pi-times" severity="secondary" 
                            (click)="hideElements('hideProperty','hide-properties',diagram)"/>
                        </div>

                        <div class="col-12 pt-1 pb-1">
                            <p-checkbox name="cellaUnita"  
                            [disabled]="mS.isCustomDistinta()"
                            (onChange)="mS.changedivisorioCella($event,cC.elencoCelle[mS.cellaCollegataInd],prev);refreshDiagram(cC.elencoCelle[mS.cellaCollegataInd].divisorioCella,'divisorioCella');" 
                            [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].cellaUnita" styleClass="mr-2" [binary]="true"></p-checkbox>
                            <label>{{lang.el('Celle unite')}}</label>
                        </div>   
                        
                        <div class="col-12 pt-1 pb-1">
                             <p-dropdown [options]="mS.divisorioCellaOptions" 
                            [disabled]="mS.isCustomDistinta() || !cC.elencoCelle[mS.cellaCollegataInd].cellaUnita"
                            appendTo="body" 
                            [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].divisorioCella" 
                            (onChange)="mS.changedivisorioCella($event,cC.elencoCelle[mS.cellaCollegataInd],prev);refreshDiagram(cC.elencoCelle[mS.cellaCollegataInd].divisorioCella,'divisorioCella');"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-12 pt-1 pb-1" *ngIf="cC.elencoCelle[mS.cellaCollegataInd].divisorioCella=='conPorta'">
                                <p-accordion>
                                <p-accordionTab header="{{lang.el('Impostazioni porta divisorio')}}" >
                                    <div class="grid">
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Tipologia')}}</label>
                                            <p-dropdown [options]="mS.tipologiaPortaOptions" 
                                            [disabled]="true || mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.tipologiaPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Verso apertura')}}</label>
                                            <p-dropdown [options]="mS.versoaperturaPortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.versoAperturaPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-0" *ngIf="false">
                                            <label>{{lang.el('Pavimento')}}</label>
                                            <p-dropdown [options]="mS.pavimentoPortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.pavimentoPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Divisorio')}}</label>
                                            <p-dropdown [options]="mS.divisorioPortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.divisorioPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                    
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Tipo')}}</label>
                                            <p-dropdown [options]="mS.tipo1PortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.tipo1Porta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Finitura')}}</label>
                                            <p-dropdown [options]="mS.tipoPortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="changeModPorta($event,cC.elencoCelle[mS.cellaCollegataInd],cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio,'divisorio')"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.tipoPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-0">
                                            <label>{{lang.el('Modello')}}</label>
                                            <p-dropdown [options]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.modelliPortaOptions" 
                                            [disabled]="mS.isCustomDistinta()"
                                            appendTo="body" [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.modelloPorta" 
                                            [style]="{'width':'100%'}"></p-dropdown>
                                        </div>
                                        <div class="col-12 pt-1 pb-1">
                                            <p-checkbox name="ruota180gradi"  
                                            [disabled]="mS.isCustomDistinta()"
                                            (onChange)="mS.changedivisorioCella($event,cC.elencoCelle[mS.cellaCollegataInd],prev);refreshDiagram(cC.elencoCelle[mS.cellaCollegataInd].divisorioCella,'divisorioCella');"
                      
                                            [(ngModel)]="cC.elencoCelle[mS.cellaCollegataInd].portaDivisorio.ruota180gradi" styleClass="mr-2" [binary]="true"></p-checkbox>
                                            <label>{{lang.el('ruota 180 gradi')}}</label>
                                        </div>
                                        
                                               
                                    </div>
                                </p-accordionTab>
                            </p-accordion>
                        </div>

                    </div>

                    <div id='textPropertyContainer' class="db-text-prop-container" style="display:none">
                        <div class="db-prop-separator" style="background-color: #b5b5b5;">
                        </div>
                        <div class="col-xs-8 db-col-left db-prop-text-style">
                            <span class="db-prop-text-style">Text</span>
                        </div>
                        <div class="col-xs-4 db-col-left db-prop-text-style">
                            <span class="db-prop-text-style">Size</span>
                        </div>
                        <div class="row db-prop-row">
                            <div class="col-xs-8 db-col-left" style="width: 145px;">
                                <ejs-dropdownlist #fontFamily height='34px' [dataSource]='dropDownDataSources.fontFamilyList' [(value)]='this.selectedItem.textProperties.fontFamily'
                                    [fields]='dropdownListFields' >
                                </ejs-dropdownlist>
                            </div>
                            <div class="col-xs-4 db-col-right">
                                <div class="db-text-container">
                                <div class="db-text-input">
                                    <ejs-numerictextbox style="width: 73px;" min="1" format="n0" step="1" [(value)]="selectedItem.textProperties.fontSize"></ejs-numerictextbox>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="row db-prop-row">
                            <div class="col-xs-6 db-col-left" id="textPositionDiv" style="width: 135px;">
                                    <ejs-dropdownlist #ddlTextPosition 
                                    [dataSource]="selectedItem.textProperties.textPositionDataSource" 
                                    type="text" id='ddlTextPosition' [value]='selectedItem.textProperties.textPosition'
                                    [fields]='dropdownListFields'
                                    (change)='diagramPropertyBinding.textPositionChange($event)'
                                    ></ejs-dropdownlist>
                            </div>
                            <div class="col-xs-4 db-col-right" id="textColorDiv" style="width: 80px;margin-left:4px">
                                <div class="db-color-container">
                                    <div class="db-color-input">
                                            <input ejs-colorpicker [(value)]="selectedItem.textProperties.fontColor"  mode="Palette"  id="textColor" type="text">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row db-prop-row" style="margin-top: 10px;">
                            <div class="col-xs-6 db-col-left">
                                <ejs-toolbar id='toolbarTextStyle' overflowMode='Scrollable' (clicked)="diagramPropertyBinding.toolbarTextStyleChange($event)">
                                    <e-items>
                                        <e-item prefixIcon="sf-icon-bold tb-icons" tooltipText="Bold" cssClass="tb-item-start">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-italic tb-icons" tooltipText="Italic" cssClass="tb-item-middle">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-underline tb-icons" tooltipText="Underline" cssClass="tb-item-end">
                                        </e-item>
                                    </e-items>
                                </ejs-toolbar>
                            </div>
                            <div class="col-xs-6 db-col-right">
                                <ejs-toolbar id='toolbarTextSubAlignment' overflowMode='Scrollable' (clicked)="diagramPropertyBinding.toolbarTextSubAlignChange($event)">
                                    <e-items>
                                        <e-item prefixIcon="sf-icon-align-left tb-icons" tooltipText="Align Text Left" cssClass="tb-item-start">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-center tb-icons" tooltipText="Align Text Center" cssClass="tb-item-middle">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-right tb-icons" tooltipText="Align Text Right" cssClass="tb-item-end">
                                        </e-item>
                                    </e-items>
                                </ejs-toolbar>
                            </div>
                        </div>
                        <div class="row db-prop-row" id='toolbarTextAlignmentDiv'>
                            <div class="col-xs-6 db-col-left">
                                <ejs-toolbar id='toolbarTextAlignmentLeft' overflowMode='Scrollable' (clicked)="diagramPropertyBinding.toolbarTextAlignChange($event)">
                                    <e-items>
                                        <e-item prefixIcon="sf-icon-align-text-left tb-icons" tooltipText="Align Right" cssClass="tb-item-start">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-text-horizontal-center tb-icons" tooltipText="Align Center" cssClass="tb-item-middle">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-text-rignt tb-icons" tooltipText="Align Left" cssClass="tb-item-end">
                                        </e-item>
                                    </e-items>
                                </ejs-toolbar>
                            </div>
                            <div class="col-xs-6 db-col-right">
                                <ejs-toolbar id='toolbarTextAlignmentTop' overflowMode='Scrollable' (clicked)="diagramPropertyBinding.toolbarTextAlignChange($event)">
                                    <e-items>
                                        <e-item prefixIcon="sf-icon-align-text-top tb-icons" tooltipText="Align Top" cssClass="tb-item-start">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-text-vertical-center tb-icons" tooltipText="Align Middle" cssClass="tb-item-middle">
                                        </e-item>
                                        <e-item prefixIcon="sf-icon-align-text-bottom tb-icons" tooltipText="Align Bottom" cssClass="tb-item-end">
                                        </e-item>
                                    </e-items>
                                </ejs-toolbar>
                            </div>
                        </div>
                        <div class="row db-prop-row">
                            
                            <div class="col-xs-2 db-col-right">
                                <input id='textOpacityText' type="text" [value]='selectedItem.textProperties.opacityText' class="db-readonly-input" readOnly="true"/>
                            </div>
                        </div>
                        <div class="db-prop-separator" style="background-color: #b5b5b5;">
                        </div>
                    </div>
                    
              </div>
          </div>

    </div>
  </div>

</div>




<p-dialog header="{{lang.el('Crea Listini')}}" [(visible)]="showDialogListini" 
[modal]="true" 
[style]="{ width: '30vw',height: '55vh'  }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        
        <div class="col-6">
            <label>{{lang.el('Modello porta con pavimento')}}</label>
            <p-dropdown [options]="listiniModelliPortaOptionsConPav" 
            appendTo="body" [(ngModel)]="listiniPortaConPav" 
            [style]="{'width':'100%'}"></p-dropdown>
        </div>
        <div class="col-6">
            <label>{{lang.el('Modello porta senza pavimento')}}</label>
            <p-dropdown [options]="listiniModelliPortaOptionsSenzaPav" 
            appendTo="body" [(ngModel)]="listiniPortaSenzaPav" 
            [style]="{'width':'100%'}"></p-dropdown>
        </div>
        <div class="col-6">
            <label>{{lang.el('Ingombro X min.')}}</label>
            <p-inputNumber 
            [min]="20"
            (onBlur)="changeIngombriListini(cC.elencoCelle[mS.currCellaInd]);"
            [(ngModel)]="listini.ingombroXMin"></p-inputNumber>
        </div>
        <div class="col-6">
            <label>{{lang.el('Ingombro X max.')}}</label>
            <p-inputNumber 
            [min]="20"
            (onBlur)="changeIngombriListini(cC.elencoCelle[mS.currCellaInd]);"
            [(ngModel)]="listini.ingombroXMax"></p-inputNumber>
        </div>
        <div class="col-6">
            <label>{{lang.el('Ingombro Y min.')}}</label>
            <p-inputNumber 
            [min]="20"
            (onBlur)="changeIngombriListini(cC.elencoCelle[mS.currCellaInd]);"
            [(ngModel)]="listini.ingombroYMin"></p-inputNumber>
        </div>
        <div class="col-6">
            <label>{{lang.el('Ingombro Y max.')}}</label>
            <p-inputNumber 
            [min]="20"
            (onBlur)="changeIngombriListini(cC.elencoCelle[mS.currCellaInd]);"
            [(ngModel)]="listini.ingombroYMax"></p-inputNumber>
        </div>
        <div class="col-12">
            <p-progressBar  *ngIf="listini.totIterazioni>0"
            [value]="percentualeAvanzamento()">
                <ng-template pTemplate="content" let-value> 
                <span>{{this.listini.currentIterazione}}/{{listini.totIterazioni}}</span>    
                </ng-template>
            </p-progressBar>
            <span  *ngIf="listini.totIterazioni==0"></span>
        </div>
        <div class="col-12 text-center" >
            <button *ngIf="listini.totIterazioni>0 && listini.ingombroYCurrent>listini.ingombroYMax"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="exportListini()"
                label="{{lang.el('Esporta listino')}}" icon="pi pi-fw pi-check">
            </button>  
            <span *ngIf="listini.totIterazioni==0"></span>
        </div>
        <div class="col-12 text-center" *ngIf="listiniError && listiniError!=''">
            <p class="error">{{listiniError}}</p>
        </div>
       
    </div>
  <p-footer>
     <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
        (click)="annullaCreazioneListini()"
        label="{{lang.el('Annulla')}}"></button>
   <button pButton 
    [disabled]="!listini.ingombroXMin || !listini.ingombroXMax || !listini.ingombroYMin || !listini.ingombroYMax"
    label="{{lang.el('Conferma')}}" class="p-button-success" (click)="startCreazioneListini(cC.elencoCelle[mS.currCellaInd])"></button>
  </p-footer>
</p-dialog>



<p-dialog header="{{lang.el('Stampa tavole')}}" [(visible)]="showDialogPrint" 
[modal]="true" 
[style]="{ width: '30vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12">
            <label>{{lang.el('Stampa')}}</label>
            <p-dropdown appendTo="body" 
                [options]="tipodistampaList" [(ngModel)]="tipoStampa"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="col-12">
            <label>{{lang.el('Formato')}}</label>
            <p-dropdown appendTo="body" 
                [options]="formatostampaList" [(ngModel)]="formatoStampa"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
    </div>
  <p-footer>
    <button pButton 
    label="{{lang.el('Stampa tavole')}}" class="p-button-success" (click)="creaPDF2()"></button>
   <button pButton 
    label="{{lang.el('DXF export')}}" class="p-button-success" (click)="creaPDF2('DXF')"></button>
  </p-footer>
</p-dialog>


<p-dialog header="{{lang.el('Attenzione')}}" [(visible)]="showError" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12" >
            <label> {{lang.el('Sono presenti errori nella configurazione:')}}</label>
        </div>
        <div class="col-12 pb-0" *ngFor="let err of errorMessage">
             {{err}}
        </div>
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showError=false"
                label="{{lang.el('Chiudi')}}"></button>
  </p-footer>
</p-dialog>



<p-dialog header="{{lang.el('Modifica descrizione e stato')}}" [(visible)]="showEditDesc" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12">
            <label>{{lang.el('Descrizione')}}</label>
            <input pInputText [(ngModel)]="cC.descrizione" class="flex-auto" autocomplete="off" />
        </div>
        <div class="col-12  pt-1 pb-1">
            <label>{{lang.el('Stato cella')}}</label>
            <p-dropdown [options]="statusCellaOptions" 
            appendTo="body" [(ngModel)]="cC.status" 
            [style]="{'width':'100%'}"></p-dropdown>
        </div>
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showEditDesc=false"
                label="{{lang.el('Annulla')}}"></button>
    <button  
            pButton pRipple class="p-button-primary flex-1 border-round" 
            (click)="confermaDescr()"
            label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
  </p-footer>
</p-dialog>

<p-dialog  header="{{lang.el('Modifica distinta scaffali')}}" [(visible)]="showEditScaffali" 
[modal]="true" 
[style]="{ width: '25vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
     
        <div class="col-12">
            <b>{{lang.el('Distinta scaffali')}}: {{profonditaScaffale}}</b>
        </div>
        <div class="col-12">
            <table>
                <tr *ngFor="let sc of elencoScaffali;index as i">
                    <td ><b>{{sc.lung}}: </b></td>
                    <td style="width:40px;"><input 
                        (change)="changeLunghScaffale()" [min]="1" [max]="20"
                        pInputText [(ngModel)]="sc.qty" class="flex-auto" autocomplete="off" />
                    </td>
                </tr>
                <tr>
                        <td class="text-right"><b>{{lang.el('Lunghezza totale')}}:</b></td>
                    <td>{{lunghtotscaffali}}</td>
                </tr>
            </table>
        </div>
      
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showEditScaffali=false"
                label="{{lang.el('Annulla')}}"></button>
    <button  
            pButton pRipple class="p-button-primary flex-1 border-round" 
            (click)="confermaDistintaScaffali()"
            label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
  </p-footer>
</p-dialog>


<p-dialog *ngIf="cC && cC.elencoCelle[mS.currCellaInd]"
header="{{lang.el('Modifica descrizione tecnica')}}" [(visible)]="showEditDescTecnica" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12">
            <label>{{lang.el('Descrizione tecnica')}}</label>
            <textarea 
                rows="5"
                pInputTextarea 
                [(ngModel)]="cC.elencoCelle[mS.currCellaInd].descrizioneTecnica">
            </textarea>
        </div>
    </div>
  <p-footer>
    <button  
            pButton pRipple class="p-button-primary flex-1 border-round" 
            (click)="confermaDescrTecnica()"
            label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
  </p-footer>
</p-dialog>



<p-toast></p-toast>

<p-confirmDialog  [acceptButtonStyleClass]="'p-button-text'"
[rejectButtonStyleClass]="'p-button-text p-button-danger'"></p-confirmDialog>


<div *ngIf="false" class="flex justify-content-center">
   <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4"></p-progressSpinner>
</div>